/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChannelOverview } from './ChannelOverview';
import {
    ChannelOverviewFromJSON,
    ChannelOverviewFromJSONTyped,
    ChannelOverviewToJSON,
    ChannelOverviewToJSONTyped,
} from './ChannelOverview';

/**
 * 
 * @export
 * @interface MarketingChannelOverviewItemData
 */
export interface MarketingChannelOverviewItemData {
    /**
     * 
     * @type {string}
     * @memberof MarketingChannelOverviewItemData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingChannelOverviewItemData
     */
    name?: string;
    /**
     * 
     * @type {ChannelOverview}
     * @memberof MarketingChannelOverviewItemData
     */
    overview?: ChannelOverview;
}

/**
 * Check if a given object implements the MarketingChannelOverviewItemData interface.
 */
export function instanceOfMarketingChannelOverviewItemData(value: object): value is MarketingChannelOverviewItemData {
    return true;
}

export function MarketingChannelOverviewItemDataFromJSON(json: any): MarketingChannelOverviewItemData {
    return MarketingChannelOverviewItemDataFromJSONTyped(json, false);
}

export function MarketingChannelOverviewItemDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingChannelOverviewItemData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'overview': json['overview'] == null ? undefined : ChannelOverviewFromJSON(json['overview']),
    };
}

export function MarketingChannelOverviewItemDataToJSON(json: any): MarketingChannelOverviewItemData {
    return MarketingChannelOverviewItemDataToJSONTyped(json, false);
}

export function MarketingChannelOverviewItemDataToJSONTyped(value?: MarketingChannelOverviewItemData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'overview': ChannelOverviewToJSON(value['overview']),
    };
}

